import { forwardRef, type Ref, type SVGProps } from "react";
const IconGiftOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29 8h-4.56A3.9 3.9 0 0 0 25 6a4 4 0 0 0-7-2.66 17 17 0 0 0-2 2.79 17 17 0 0 0-2-2.79A4 4 0 0 0 7 6a3.9 3.9 0 0 0 .56 2H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h1v9a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3v-9h1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1m-9.49-3.34A2 2 0 1 1 21 8h-3.71a13.2 13.2 0 0 1 2.22-3.34M9 6a2 2 0 0 1 3.49-1.34A13.2 13.2 0 0 1 14.71 8H11a2 2 0 0 1-2-2m-5 4h9v6H4Zm3 18a1 1 0 0 1-1-1v-9h7v10Zm8 0V10h2v18Zm11-1a1 1 0 0 1-1 1h-6V18h7Zm2-11h-9v-6h9Z" />
  </svg>
);
const ForwardRef = forwardRef(IconGiftOutlineSVG);
ForwardRef.displayName = "IconGiftOutline";
export { ForwardRef as IconGiftOutline };
